import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { LoaderSizes, LoaderThemes } from '@shared/v2/models';
import { SdvorIconComponent } from '../icon/icon.component';

/**
 * `SdvorLoaderComponent` отвечает за отображение анимации загрузки или индикатора ожидания
 * во время выполнения длительных операций.
 *
 * ```ts
 * import { SdvorLoaderComponent } from '@sdvor/shared/ui/v2';
 * ```
 */
@Component({
  selector: 'sd-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SdvorIconComponent],
})
export class SdvorLoaderComponent {
  /** Размер лоадера */
  @Input() size: LoaderSizes = 's';
  /** Цветовая тема */
  @Input() theme: LoaderThemes = 'orange';

  /** @ignore */
  @HostBinding('class')
  get classNames(): string[] {
    return ['loader', this.size && `loader-size-${this.size}`, this.theme && `loader-theme-${this.theme}`].filter(
      Boolean,
    );
  }
}
